import { render, staticRenderFns } from "./PopupCommentAdd.vue?vue&type=template&id=38af325c&scoped=true&lang=pug&"
import script from "./PopupCommentAdd.vue?vue&type=script&lang=coffee&"
export * from "./PopupCommentAdd.vue?vue&type=script&lang=coffee&"
import style0 from "./PopupCommentAdd.vue?vue&type=style&index=0&id=38af325c&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "38af325c",
  null
  
)

export default component.exports